import { CommonModule } from "@angular/common";
import { ChangeDetectionStrategy, Component } from "@angular/core";
import { localize } from "@gtmhub/localization";
import { HomeWidgetService } from "@webapp/home/services/home-widget.service";
import { LocalizationModule } from "@webapp/localization/localization.module";
import { UiButtonModule } from "@webapp/ui/button/button.module";
import { UiCardModule } from "@webapp/ui/card/card.module";
import { BaseWidgetComponent } from "@webapp/ui/dashboard/components/base-widget.component";
import { UiIconModule } from "@webapp/ui/icon/icon.module";
import { UiLinkModule } from "@webapp/ui/link/link.module";
import { UiToastService } from "@webapp/ui/toast/services/toast.service";

@Component({
  selector: "kickstart-okr-widget",
  templateUrl: "./kickstart-okr-widget.component.html",
  styleUrls: ["./kickstart-okr-widget.component.less"],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [UiButtonModule, UiCardModule, UiIconModule, CommonModule, UiLinkModule, LocalizationModule],
})
export class KickstartOkrWidgetComponent extends BaseWidgetComponent {
  public boxes = [
    { icon: "help", type: localize("support_center"), title: localize("get_advice_and_answers"), link: "https://help.quantive.com/en/" },
    { icon: "award", type: localize("okr_courses"), title: localize("expand_okr_skills"), link: "https://quantive.com/resources/certifications" },
    { icon: "users-group", type: localize("community"), title: localize("join_community"), link: "https://community.quantive.com" },
    { icon: "calendar", type: localize("events"), title: localize("register_for_events"), link: "https://quantive.com/resources/events" },
  ];

  public get title(): string {
    return localize("kickstart_okr_success");
  }

  constructor(private homeWidgetService: HomeWidgetService, private toastService: UiToastService) {
    super();
  }

  public close(): void {
    this.homeWidgetService.removeWidget(this.widgetId);

    const message = localize("you_can_find_resources_in_support_center");
    this.toastService.success(message, {
      uiShouldTimeout: true,
      uiDuration: 5000,
      uiPrimaryCTA: localize("undo"),
      uiOnPrimaryAction: () => this.homeWidgetService.addWidget(this.widgetId),
    });
  }
}
